import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType, EventMessage, AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalConfig } from './utils/authConfig';

import './MuseDashboard.css';

import App from './App';

const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

const acquireTokenSilently = async () => {
  const request = {
    scopes: ['user.read'],
    account: msalInstance.getAllAccounts()[0],
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    console.log('New token acquired:', response.accessToken);
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      msalInstance.acquireTokenRedirect(request);
    } else {
      console.error('Token acquisition failed:', error);
    }
  }
};

const TOKEN_REFRESH_INTERVAL = 50 * 60 * 1000; // 50 minutes in milliseconds

const startTokenRefreshTimer = () => {
  setInterval(acquireTokenSilently, TOKEN_REFRESH_INTERVAL);
};

// Start the token refresh timer when the application loads
startTokenRefreshTimer();

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const account = (event.payload as AccountInfo);
    msalInstance.setActiveAccount(account);
    startTokenRefreshTimer();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App instance={msalInstance}/>
  </React.StrictMode>
);
